import { Link } from "gatsby"
import PropTypes from "prop-types"
import React from "react"
import { useState, useEffect } from "react"
import authClient from "../../auth"
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Button from 'react-bootstrap/Button'
import Accordion from 'react-bootstrap/Accordion';
import Card from 'react-bootstrap/Card';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAngleRight, faAngleLeft, faBars, faEnvelope } from '@fortawesome/free-solid-svg-icons'
import Image from "../image"
import OpenApp from "react-open-app";
import NavContactBgImage from '../../images/nav_contact_bg_image.png'
import "../layout.scss"
import Styles from "../desktop-left-navigation.module.scss"

const isBrowser = () => typeof window !== "undefined"
const localSt_license = isBrowser() ? (localStorage.getItem('license_title') ? localStorage.getItem('license_title') : 'Basic') :  ''

const MobileLeftNavigation = props => {
  const [activeKey, setActiveKey] = useState('0')
  const [activeButton, setActiveButton] = useState('')
  const [brand_icon_display, setBrandIconDisplay] = useState(true)

  const followBrandIcon = e => {
    e.preventDefault();
    setBrandIconDisplay(!brand_icon_display)
  }

  function showPrimeContentLink() {
    if (localSt_license !== 'Basic') {
      return(
        <div className={` ${activeButton.includes('prime-content') ? Styles.left_nav_link_active : Styles.left_nav_link} `}  onClick={ () => {setActiveButton('prime-content');}} >
          <div className="d-flex font-w500" style={{alignItems:'center'}} >
            <div className={`d-flex`}><span id={'prime_content'} style={{marginLeft: '-5px'}} className={`sprite_image_4 ${localSt_license === 'Prime' ? `${Styles.nav_prime_icon}` : `${Styles.nav_value_icon}`} mr-1`}></span></div>My {localSt_license} Content
          </div>
        </div>
      )
    } else {
      return null
    }
  }

  return(
      <div style={{width:'240px',transform: props.open ? 'translateX(0)' : 'translateX(-100%)', display: 'flex',
        flexDirection: 'column',
        padding: '0rem',
        position: 'absolute',
        top: '48px',
        left: 0,
        transition: 'transform .5s ease-in-out',
        backgroundColor: '#f0f7ff',
        borderBottomRightRadius: '10px',
        boxShadow: 'rgb(0 0 0 / 16%) 0px 3px 7px 0px',
        maxHeight: 'calc(100vh - 96px)',
        overflowY:'auto',
        overflowX: 'hidden', zIndex: 2 }} >
        <Accordion activeKey={activeKey}>
          <Card className={`${Styles.border_bg_none} ${activeKey === '0' ? 'bg-white' : Styles.border_bg_none}`}>
              <Accordion.Toggle as={Card.Header} eventKey="0" className={`pointer ${Styles.border_bg_none} pl-4`} onClick={ () => {setActiveKey(activeKey === '0' ? '' : '0');setActiveButton('');}} >
                {/*<OpenApp
                  href="https://leanpitch.com"
                  android="https://play.google.com/store/apps/details?id=com.leanpitch.light"
                  ios="https://apps.apple.com/in/app/leanpitch/id1484239786"
                >*/}
                  <div className={`${activeKey === '0' ? Styles.left_nav_link_header_active : Styles.left_nav_link_header} d-inline-flex`} >
                    <div className={`d-flex`}><span className={`sprite_image_2 ${activeKey === '0' ? `${Styles.dashboard_icon_white}` : `${Styles.dashboard_icon_black}`} mr-2 my-auto`}></span></div>
                    My Dashboard
                    <div className={`d-flex`}><span className={`sprite_image_2 ${activeKey === '0' ? 'down_white_arrow' : `down_black_arrow rotate-right`} ml-2 my-auto`}></span></div>
                  </div>
                {/*</OpenApp>*/}
              </Accordion.Toggle>
            <Accordion.Collapse eventKey="0">
              <React.Fragment>
              <Card.Body className={`d-grid ${Styles.border_bg_none} py-2 pr-0 pl-2 ml-3`} >
                <Link className={` ${activeButton.includes('my-trainings') ? Styles.left_nav_link_active : Styles.left_nav_link} `} to="/my-trainings" activeClassName={`${Styles.left_nav_link_active}`}  onClick={ () => {setActiveButton('my-trainings');}}>
                  <div className="d-flex font-w500" >
                    <div className={`d-flex`}><span id={'my_trainings'} className={`sprite_image_small_2 ${activeButton.includes('my-trainings') ? `${Styles.training_icon_blue}` : `${Styles.training_icon_black}`} mr-2 my-auto`}></span></div>My Trainings
                  </div>
                </Link>
                <Link className={` ${activeButton.includes('videos') ? Styles.left_nav_link_active : Styles.left_nav_link} `} to="/videos" activeClassName={`${Styles.left_nav_link_active}`}  onClick={ () => {setActiveButton('videos');}}>
                  <div className="d-flex font-w500" >
                    <div className={`d-flex`}><span id={'my_videos'} className={`sprite_image_small_2 ${activeButton.includes('videos') ? `${Styles.play_blue_icon}` : `${Styles.play_black_icon}`} mr-2 my-auto`}></span></div>My Videos
                  </div>
                </Link>
                <Link className={` ${activeButton.includes('blogs') ? Styles.left_nav_link_active : Styles.left_nav_link} `} to="/blogs" activeClassName={`${Styles.left_nav_link_active}`}  onClick={ () => {setActiveButton('blogs');}}>
                  <div className="d-flex font-w500" >
                    <div className={`d-flex`}><span id={'my_blog'} className={`sprite_image_small_2 ${activeButton.includes('blogs') ? `${Styles.blog_blue_icon}` : `${Styles.blog_black_icon}`} mr-2 my-auto`}></span></div>My Blogs
                  </div>
                </Link>
                <Link className={` ${activeButton.includes('events') ? Styles.left_nav_link_active : Styles.left_nav_link} `} to="/events" activeClassName={`${Styles.left_nav_link_active}`}  onClick={ () => {setActiveButton('events');}}>
                  <div className="d-flex font-w500" >
                    <div className={`d-flex`}><span id={'my_events'} className={`sprite_image_small_2 ${activeButton.includes('events') ? `${Styles.events_blue_icon}` : `${Styles.events_black_icon}`} mr-2 my-auto`}></span></div>My Events
                  </div>
                </Link>
                <Link className={` ${activeButton.includes('my-quizzes') ? Styles.left_nav_link_active : Styles.left_nav_link} `} to="/my-quizzes" activeClassName={`${Styles.left_nav_link_active}`} onClick={ () => {setActiveButton('my-quizzes');}}>
                  <div className="d-flex font-w500" >
                    <div className={`d-flex`}><span id={'my-quizzes'} className={`sprite_image_small_2 ${activeButton.includes('my-quizzes') ? `${Styles.quiz_blue_icon}` : `${Styles.quiz_black_icon}`} mr-2 my-auto`}></span></div>My Quizzes
                  </div>
                </Link>
                <Link className={` ${activeButton.includes('resources') ? Styles.left_nav_link_active : Styles.left_nav_link} `} to="/resources" activeClassName={`${Styles.left_nav_link_active}`}  onClick={ () => {setActiveButton('resources');}} >
                  <div className="d-flex font-w500" >
                    <div className={`d-flex`}><span id={'my_resources'} className={`sprite_image_small_2 ${activeButton.includes('resources') ? `${Styles.resources_blue_icon}` : `${Styles.resources_black_icon}`} mr-2 my-auto`}></span></div>My Resources
                  </div>
                </Link>
                <Link className={` ${activeButton.includes('web-recordings') ? Styles.left_nav_link_active : Styles.left_nav_link} `} to="/web-recordings" activeClassName={`${Styles.left_nav_link_active}`}  onClick={ () => {setActiveButton('web-recordings');}} >
                  <div className="d-flex font-w500" >
                    <div className={`d-flex`}><span id={'my_podcast'} className={`sprite_image_small_2 ${activeButton.includes('web-recordings') ? `${Styles.record_blue_icon}` : `${Styles.record_black_icon}`} mr-2 my-auto`}></span></div>Webinar Recordings
                  </div>
                </Link>
                <Link className={` ${activeButton.includes('my-speak-series') ? Styles.left_nav_link_active : Styles.left_nav_link} `} to="/my-speak-series" activeClassName={`${Styles.left_nav_link_active}`}  onClick={ () => {setActiveButton('my-speak-series');}}>
                  <div className="d-flex font-w500" >
                    <div className={`d-flex`}><span id={'my_series'} className={`sprite_image_small_2 ${activeButton.includes('my-speak-series') ? `${Styles.expert_blue_icon}` : `${Styles.expert_black_icon}`} mr-2 my-auto`}></span></div>Expert Speak Series
                  </div>
                </Link>
                <Link className={` ${activeButton.includes('book-mentor') ? Styles.left_nav_link_active : Styles.left_nav_link} `} to="/book-mentor" activeClassName={`${Styles.left_nav_link_active}`}  onClick={ () => {setActiveButton('book-mentor');}}>
                  <div className="d-flex font-w500" >
                    <div className={`d-flex`}><span id={'book_mentor'} className={`sprite_image_small_2 ${activeButton.includes('book-mentor') ? `${Styles.events_blue_icon}` : `${Styles.events_black_icon}`} mr-2 my-auto`}></span></div>Talk to a Mentor
                  </div>
                </Link>
                <OpenApp
                  href="https://leanpitch.com"
                  android="https://eskola.io/PrimeContent"
                  ios="leanpitch://leanpitch.com/LoginDashboard"
                >
                  {showPrimeContentLink()}
                </OpenApp>
              </Card.Body>
              <OpenApp
                  href="https://leanpitch.com"
                  android="https://eskola.io/LoginDashboard"
                  ios="leanpitch://leanpitch.com/LoginDashboard"
                >
                {/*<Image src={'view_on_app.png'} imgStyle={{ objectFit: `cover` }} style={{width:'220px', margin:'auto'}} type='fluid' />*/}
                <p style={{fontSize:'13px',textAlign:'center',padding:'0px 10px'}} >You can view your dashboard on app</p>
                <div className="text-center" >
                  <Button size="sm"
                    style={{borderRadius: '15px', padding: '3px 15px', margin: '10px 0px', color: `#ffffff`, background: `#46a5ef`, border: 0}} >
                    View on App
                  </Button>
                </div>
              </OpenApp>
              </React.Fragment>
            </Accordion.Collapse>
          </Card>
          <Card className={` ${activeKey === '2' ? 'bg-white' : Styles.card_border}`} style={{borderTop: '1px solid #ebe8e8', borderBottom: '1px solid #ebe8e8'}}>
            <Accordion.Toggle as={Card.Header} eventKey="2" className={`${Styles.border_bg_none} ${Styles.left_nav_link_header} pl-4`} onClick={ () => {setActiveKey(activeKey === '2' ? '' : '2')}} >
              <div className={`${activeKey === '2' ? Styles.left_nav_link_header_active : Styles.left_nav_link_header} d-inline-flex`} >
                <div className={`d-flex`}><span className={`sprite_image_2 ${activeKey === '2' ? `${Styles.lp_icon_white}` : `${Styles.lp_icon_black}`} mr-2 my-auto`}></span></div>
                About Us
                <div className={`d-flex`}><span className={`sprite_image_2 ${activeKey === '2' ? 'down_white_arrow' : 'down_black_arrow rotate-right'} ml-2 my-auto`}></span></div>
              </div>
            </Accordion.Toggle>
            <Accordion.Collapse eventKey="2">
              <Card.Body className={`d-grid ${Styles.border_bg_none} py-2 pr-0 pl-2 ml-3`} >
                <Link className={` ${activeButton.includes('about-us') ? Styles.left_nav_link_active : Styles.left_nav_link} `} to="/about-us" activeClassName={`${Styles.left_nav_link_active}`} onClick={ () => {setActiveButton('our-team');}}>
                  <div className="d-flex font-w500" >
                    <div className={`d-flex`}><span id={'about_us'} className={`sprite_image_small_2 ${activeButton.includes('our-team') ? `${Styles.play_blue_icon}` : `${Styles.play_black_icon}`} mr-2 my-auto`}></span></div>Our team
                  </div>
                </Link>
                <Link className={` ${activeButton.includes('why-us') ? Styles.left_nav_link_active : Styles.left_nav_link} `} to="/why-us" activeClassName={`${Styles.left_nav_link_active}`} onClick={ () => {setActiveButton('why-us');}}>
                  <div className="d-flex font-w500" >
                    <div className={`d-flex`}><span id={'why_us'} className={`sprite_image_small_2 ${activeButton.includes('why-us') ? `${Styles.play_blue_icon}` : `${Styles.play_black_icon}`} mr-2 my-auto`}></span></div>Why Us
                  </div>
                </Link>
                <Link className={` ${activeButton.includes('ourtrainers') ? Styles.left_nav_link_active : Styles.left_nav_link} `} to="/ourtrainers" activeClassName={`${Styles.left_nav_link_active}`} onClick={ () => {setActiveButton('ourtrainers');}}>
                  <div className="d-flex font-w500" >
                    <div className={`d-flex`}><span id={'ourtrainers'} className={`sprite_image_small_2 ${activeButton.includes('ourtrainers') ? `${Styles.training_icon_blue}` : `${Styles.training_icon_black}`} mr-2 my-auto`}></span></div>Our Trainers
                  </div>
                </Link>
                <Link className={` ${activeButton.includes('our-presence') ? Styles.left_nav_link_active : Styles.left_nav_link} `} to="/our-presence" activeClassName={`${Styles.left_nav_link_active}`} onClick={ () => {setActiveButton('our-presence');}} >
                  <div className="d-flex font-w500" >
                    <div className={`d-flex`}><span id={'our_presence'} className={`sprite_image_small_2 ${activeButton.includes('our-presence') ? `${Styles.play_blue_icon}` : `${Styles.play_black_icon}`} mr-2 my-auto`}></span></div>Our Presence
                  </div>
                </Link>
                {//<Link className={` ${activeButton.includes('about-us') ? Styles.left_nav_link_active : Styles.left_nav_link} `} to="/about-us/" activeClassName={`${Styles.left_nav_link_active}`} onClick={ () => {setActiveButton('about-us');}}
                  //   onMouseOver={(e) => {onMouseOver(e,'our_products',`${Styles.play_blue_icon}`,`${Styles.play_black_icon}`,'about-us')}}
                  //   onMouseOut={(e) => {onMouseOut(e,'our_products',`${Styles.play_blue_icon}`,`${Styles.play_black_icon}`,'about-us')}}
                  //   onFocus={ () => void 0 }
                  //   onBlur={ () => void 0 } >
                  //   <div className="d-flex font-w500" >
                  //     <div className={`d-flex`}><span id={'our_products'} className={`${activeButton.includes('about-us') ? `${Styles.play_blue_icon}` : `${Styles.play_black_icon}`} mr-2 my-auto`}></span></div>Our Products
                  //   </div>
                  // </Link>
                }
                <Link className={` ${activeButton.includes('leanpitch-reviews') ? Styles.left_nav_link_active : Styles.left_nav_link} `} to="/leanpitch-reviews" activeClassName={`${Styles.left_nav_link_active}`} onClick={ () => {setActiveButton('leanpitch-reviews');}}>
                  <div className="d-flex font-w500" >
                    <div className={`d-flex`}><span id={'leanpitch-reviews'} className={`sprite_image_small_2 ${activeButton.includes('leanpitch-reviews') ? `${Styles.play_blue_icon}` : `${Styles.play_black_icon}`} mr-2 my-auto`}></span></div>Testimonials
                  </div>
                </Link>
                {// <Link className={` ${activeButton.includes('about-us') ? Styles.left_nav_link_active : Styles.left_nav_link} `} to="/about-us/" activeClassName={`${Styles.left_nav_link_active}`} onClick={ () => {setActiveButton('about-us');}}
                //   onMouseOver={(e) => {onMouseOver(e,'lp_tv',`${Styles.play_blue_icon}`,`${Styles.play_black_icon}`,'about-us')}}
                //   onMouseOut={(e) => {onMouseOut(e,'lp_tv',`${Styles.play_blue_icon}`,`${Styles.play_black_icon}`,'about-us')}}
                //   onFocus={ () => void 0 }
                //   onBlur={ () => void 0 } >
                //   <div className={`d-flex font-w500`} >
                //     <div className={`d-flex`}><span id={'lp_tv'} className={`${activeButton.includes('about-us') ? `${Styles.play_blue_icon}` : `${Styles.play_black_icon}`} mr-2 my-auto`}></span></div>LP TV
                //   </div>
                // </Link>
                }
              </Card.Body>
            </Accordion.Collapse>
          </Card>
          <div className="float-left pb-1" style={{display: 'inline-block',backgroundImage: `url(${NavContactBgImage})`, backgroundRepeat: 'no-repeat', backgroundSize: '100%', objectFit: 'cover'}}>
            <div className="d-flex font-w500 float-left w-100 pl-4 pt-1">
              <div className={`d-flex`}><span className={`sprite_image_2 ${Styles.phone_icon_black} mr-2 my-auto`}></span></div>
              Contact Us
            </div>
            <div className="float-left w-100 d-grid justify-center" style={{fontSize: '13px'}}>
              <a className={`text-black`} href="tel:+919606796005">+91-9606796005</a>
              <a className={`text-black`} href="tel:+917358062677">+91-7358062677</a>
            </div>
            <div className="d-flex font-w500 float-left w-100 pl-4 pt-1">
              <FontAwesomeIcon className='mr-2 my-auto' icon={faEnvelope} size="1x" style={{color: 'rgb(128 128 128)'}}/>Mail Us
            </div>
            <div className="float-left w-100 d-grid justify-center mb-2" style={{fontSize: '13px'}}>
              <a className={`text-black`} href="mailto:info@leanpitch.com?Subject=Agile and Scrum Training" target="_blank" rel="noreferrer noopener">info@leanpitch.com</a>
            </div>
          </div>
        </Accordion>
      </div>
  )
}

export default MobileLeftNavigation